import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {IconButton} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {bool} from 'prop-types';

import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import ActiveSidebarElementIndicator from '../ActiveSidebarElementIndicator/ActiveSidebarElementIndicator';
import MorePopperArrow from '../MorePopperArrow/MorePopperArrow';

const OpenMoreReportsOrModulesPopperButton = ({canDisplayAllItems, isMoreReportsButton}) => {
  const {isMoreReportsPopperOpen, setIsMoreReportsPopperOpen, setMoreReportsPopperAnchorEl, isMoreModulesPopperOpen, setIsMoreModulesPopperOpen, setMoreModulesPopperAnchorEl} = useMainSidebar();

  if (canDisplayAllItems) return null;

  const isPopperOpen = isMoreReportsButton ? isMoreReportsPopperOpen : isMoreModulesPopperOpen;
  const setIsPopperOpen = isMoreReportsButton ? setIsMoreReportsPopperOpen : setIsMoreModulesPopperOpen;
  const setPopperAnchorEl = isMoreReportsButton ? setMoreReportsPopperAnchorEl : setMoreModulesPopperAnchorEl;

  return (
    <Grid container justifyContent="space-between" flexWrap="nowrap">
      <ActiveSidebarElementIndicator isVisible={isPopperOpen} />
      <IconButton
        sx={{
          ml: isPopperOpen ? 1.6 : -1
        }}
        aria-label="close"
        color="inherit"
        size="small"
        onClick={e => {
          setPopperAnchorEl(e.currentTarget);
          setIsPopperOpen(true);
        }}
      >
        <MoreHorizIcon fontSize="large" sx={{cursor: 'pointer'}} />
      </IconButton>
      {isPopperOpen ? <MorePopperArrow /> : <Box />}
    </Grid>
  );
};

OpenMoreReportsOrModulesPopperButton.propTypes = {
  canDisplayAllItems: bool.isRequired,
  isMoreReportsButton: bool.isRequired
};

export default OpenMoreReportsOrModulesPopperButton;
